import * as yup from 'yup'

export const contactValidationSchema = yup.object().shape({
	mainFirstName: yup
		.string()
		.min(2, 'Your first name must be 2 characters minimum.')
		.max(20, 'Your first name must be 20 characters maximum.')
		.required('A first name is required'),
	mainLastName: yup
		.string()
		.min(2, 'Your last name must be 2 characters minimum.')
		.max(20, 'Your last name must be 20 characters maximum.')
		.required('A last name is required'),
	mainCompany: yup.string().required('A company is required'),
	mainEmail: yup
		.string()
		.email('Your input do not match the email format.')
		.required('An email is required'),
	mainPhone: yup.string().optional(),
	mainSubject: yup
		.string()
		.required('Please select a subject')
		.notOneOf([''], 'Please select a valid option'),
	mainMessage: yup
		.string()
		.min(50, 'Your message must be 50 characters minimum.')
		.max(800, 'Your message must be 800 characters maximum.')
		.required('A message is required'),
	placeOfBirth: yup.string().optional(),
})

export type Inputs = yup.InferType<typeof contactValidationSchema>
